<template>
  <div class="container">
    <!-- HEADER -->
    <div class="header row p-0 m-0">
      <div class="col-12 col-lg-6 p-0 m-0">
        <img :src="`${publicPath}img/Grupo-de-desplazamiento-23.jpg`" data-aos="fade-left" data-aos-duration="1000" class="img-responsive">
      </div>
      <div class="col-12 col-lg-6 text-start px-5 pt-5">
        <h2 class="text-blue m-0 mt-3 p-0">{{ $t('nuevoplan.title') }}</h2>
        <h1 class="text-blue m-0 p-0">{{ $t('nuevoplan.actuando') }} </h1>
        <p>{{ $t('nuevoplan.el_nuevo_plan') }}</p>
      </div>
    </div>
    <!-- end HEADER -->

    <section class="p-0 p-lg-5 pb-lg-0 mx-0 mx-lg-5">
      <div class="row g-0 p-0 m-0">
        <h2 class="p-0 m-0 mb-5 mt-5 mt-lg-0">{{ $t('nuevoplan.cuatro') }}</h2>
        <div class="col-12 col-lg-4 text-center text-lg-end  position-relative">

          <h6 class="text-blue"><strong>{{ $t('nuevoplan.gente_saludable') }}</strong></h6>
          <p class="text-black">{{ $t('nuevoplan.compromiso') }}</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
          <p></p>
          <div  class="position-absolute bottom-0">
            <h6 class="text-blue"><strong>{{ $t('nuevoplan.planeta') }}</strong></h6>
            <p class="text-black">{{ $t('nuevoplan.gestion') }}</p>
          </div>
        </div>
        <div class="col-12 col-lg-4 text-end">
          <img :src="`${publicPath}img/Grupo-2477B${locale}.jpg`" class="img-responsive">
        </div>
        <div class="col-12 col-lg-4 text-center text-lg-start  position-relative">
          <h6 class="text-blue"><strong>{{ $t('nuevoplan.entidad') }}</strong></h6>
          <p class="text-black">{{ $t('nuevoplan.apuesta') }}</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
          <p></p>
          <div  class="position-absolute bottom-0">
            <h6 class="text-blue"><strong>{{ $t('nuevoplan.sociedad') }}</strong></h6>
            <p class="text-black">{{ $t('nuevoplan.fomento') }}</p>
          </div>
        </div>
        <a href="https://www.youtube.com/watch?v=hAsObvWk7cc" class="btnPlus p-3" target="_blank"><img :src="`${publicPath}img/btnLink.png`" class="img-responsive">  <strong>{{ $t('literals.vervideo') }}</strong></a>
      </div>

    </section>

    <section class="p-0 p-lg-5 m-3 m-lg-5 mb-0 pb-0">
      <div class="row">
        <div class="col-12 col-lg-6 text-center text-lg-start pe-2 pe-lg-5" data-aos="fade-in" data-aos-delay="200" data-aos-duration="1000" data-aos-id="start-counter">
          <h6><strong>{{ $t('nuevoplan.analisis') }}</strong></h6>
          <p class="text-black">{{ $t('nuevoplan.lineas') }}</p>
        </div>
        <div class="col-12 col-lg-6">
          <div class="container border border-light p-3 m-0">
            <div class="row align-items-top">
              <div class="col-12 col-lg-6 pt-2">
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_profesionales'
                    :startAmount='0'
                    :endAmount='667'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /></h2>
                <p class="textSmall">{{ $t('nuevoplan.respuestas_profesionales') }}</p>
              </div>
              <div class="col-12 col-lg-6 pt-2">
                <h2 class="p-0 m-0"><AnimatedNumber
                    ref='counter_grupos'
                    :startAmount='0'
                    :endAmount='844'
                    :duration='3'
                    prefix=''
                    suffix=''
                    :separator=separator
                    :decimalSeparator=decimal_separator
                    :decimals='0'
                    :autoinit='true'
                    @finished='counterFinished'
                /></h2>
                <p class="textSmall">{{ $t('nuevoplan.respuestas_grupos') }}</p>
              </div>
            </div>
          </div>
          <hr class="filigrana mb-0">
        </div>
      </div>
    </section>

    <section class="p-0 p-lg-5 mx-0 mx-lg-5">
      <div class="g-0 p-0 m-0 px-5" data-aos="fade-in" data-aos-delay="200" data-aos-duration="1000" data-aos-id="start-counter-pacientes">
        <h2>{{ $t('nuevoplan.actualizacion') }}</h2>
        <h6 class="text-black my-3"><strong>{{ $t('nuevoplan.en_el_primers') }}</strong></h6>
      </div>
      <div class="col-12 col-lg-7 m-auto">
        <div class="container border border-light p-3 m-0">
          <div class="row align-items-top">
            <div class="col-12 col-lg-4 px-4" data-aos="fade" data-aos-delay="100" data-aos-duration="1000" >
              <img :src="`${publicPath}img/gifF1A.gif`" class="img-responsive">
              <p class="textSmall"><strong>{{ $t('nuevoplan.poblacion_protegida') }}</strong></p>
            </div>
            <div class="col-12 col-lg-4 px-4" data-aos="fade" data-aos-delay="200" data-aos-duration="1000">
              <img :src="`${publicPath}img/gifF1B.gif`" class="img-responsive">
              <p class="textSmall"><strong>{{ $t('nuevoplan.empleados') }}</strong></p>
            </div>
            <div class="col-12 col-lg-4 px-4" data-aos="fade" data-aos-delay="300" data-aos-duration="1000">
              <img :src="`${publicPath}img/gifF1C.gif`" class="img-responsive">
              <p class="textSmall"><strong>{{ $t('nuevoplan.proveedores') }}</strong></p>
            </div>
          </div>
          <div class="row align-items-top">
            <div class="col-12 col-lg-4 px-4" data-aos="fade" data-aos-delay="500" data-aos-duration="1000">
              <img :src="`${publicPath}img/gifF2A.gif`" class="img-responsive">
              <p class="textSmall"><strong>{{ $t('nuevoplan.empresas_activas') }}</strong></p>
            </div>
            <div class="col-12 col-lg-4 px-4" data-aos="fade" data-aos-delay="600" data-aos-duration="1000">
              <img :src="`${publicPath}img/gifF2B.gif`" class="img-responsive">
              <p class="textSmall"><strong>{{ $t('nuevoplan.organos') }}</strong></p>
            </div>
            <div class="col-12 col-lg-4 px-4" data-aos="fade" data-aos-delay="700" data-aos-duration="1000">
              <img :src="`${publicPath}img/gifF2C.gif`" class="img-responsive">
              <p class="textSmall"><strong>{{ $t('nuevoplan.afministracion') }}</strong></p>
            </div>
          </div>
          <div class="row align-items-top" data-aos="fade" data-aos-delay="900" data-aos-duration="1000">
            <div class="col-12 col-lg-4 px-4">
              <img :src="`${publicPath}img/gifF3A.gif`" class="img-responsive">
              <p class="textSmall"><strong>{{ $t('nuevoplan.asesorias') }}</strong></p>
            </div>
            <div class="col-12 col-lg-4 px-4" data-aos="fade" data-aos-delay="1000" data-aos-duration="1000">
              <img :src="`${publicPath}img/gifF3B.gif`" class="img-responsive">
              <p class="textSmall"><strong>{{ $t('nuevoplan.sector') }}</strong></p>
            </div>
            <div class="col-12 col-lg-4 px-4" data-aos="fade" data-aos-delay="1100" data-aos-duration="1000">
              <img :src="`${publicPath}img/gifF3C.gif`" class="img-responsive">
              <p class="textSmall"><strong>{{ $t('nuevoplan.soci') }}</strong></p>
            </div>
          </div>
        </div>
        <hr class="filigrana">
      </div>
    </section>

    <!-- NAVEGACIÓ PRE-FOOTER -->
    <hr>
    <div class="row p-0 g-0 mb-3">
      <div class="col-6 p-0 m-0 pb-3 text-start">
        <localized-link class="footerLink" to="/sostenibilidad"><img :src="`${publicPath}img/arrowLeft.png`" class="img-responsive arrowsFooter"> {{ $t("nav.sostenibilidad") }}</localized-link>
      </div>
      <div class="col-6 p-0 m-0 pb-3 text-end textSmall">
        <localized-link class="footerLink" to="/sostenibilidad/nuestra-contribucion-a-los-ods"> {{ $t("nav.nuestra-contribucion-a-los-ods") }} <img :src="`${publicPath}img/arrowRight.png`" class="img-responsive arrowsFooter"></localized-link>
      </div>
    </div>

  </div>

</template>

<script>
import AnimatedNumber from "vue3-autocounter";

export default {
  components: {
    AnimatedNumber,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      separator: '.',
      decimal_separator: ',',
      locale:this.$i18n.locale,
    }
  },
  mounted() {
    document.addEventListener('aos:in:start-counter', this.startCounter);
    if(this.$i18n.locale=="en"){
      this.separator = ',';
      this.decimal_separator = '.';
    } else {
      this.separator = '.';
      this.decimal_separator = ',';
    }
  },
  methods: {
    startCounter() {
      if (this.$refs.counter_profesionales != null) {
        this.$refs.counter_profesionales.start();
      }
      if (this.$refs.counter_grupos != null) {
        this.$refs.counter_grupos.start();
      }

    }
  }
}
</script>
